import { render, staticRenderFns } from "./answerReport.vue?vue&type=template&id=ec4be928&"
import script from "./answerReport.vue?vue&type=script&lang=js&"
export * from "./answerReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports